<template>
  <b-media vertical-align="center">
    <template
      v-if="imgProp"
      #aside
    >
      <imgWithNoImageError
        :src="src"
        :alt="item.title"
        height="70px"
        width="70px"
        :class="'img-list-thumbnail'"
      />
    </template>
    <b-link
      v-if="link"
      :to="{
        name: link,
        params: { id: item._id, lang: lang },
      }"
      class="text-nowrap custom-link"
    >
      {{ item.title }}
    </b-link>
  </b-media>
</template>
<script>
import { BMedia, BLink } from 'bootstrap-vue'
import imgWithNoImageError from '@/components/img-with-no-image-error.vue'

export default {
  name: 'BMediaCustom',
  components: {
    BMedia,
    BLink,
    imgWithNoImageError,
  },
  props: ['item', 'imgProp', 'link', 'lang'],
  computed: {
    src() {
      return this.item[this.imgProp]
        ? this.createFullFileAddress(this.item[this.imgProp])
        : ''
    },
  },
  methods: {
    createFullFileAddress({
      baseUrl, bucketName, destination, filename,
    }) {
      return `${baseUrl + bucketName}/${destination}${filename}`
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-link {
  color: #2828ab;
  min-height: 50px;
  display: flex;
  align-items: center;
  font-weight: bold;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.05);
  }
}
</style>
